import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colourPrimary, colourMasterLight, colourWhite } from 'Styles/colors.css';

const MULTIPLE = 'multiple';

const Label = styled.label`
  display: inline-block;
  position: relative;
  width: 40px;
  height: 24px;
`;

const Slider = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  -webkit-transition: .4s;
  transition: .4s;
  border-radius: 34px;
  background-color: ${colourMasterLight};
  cursor: pointer;

  &::before {
    position: absolute;
    bottom: 1px;
    left: 1px;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 50%;
    background-color: ${colourWhite};
    height: 22px;
    width: 22px;
    content: "";
  }
`;

const Input = styled.input`
  display:none;

  &:checked + .slider {
    background-color: ${colourPrimary};
  }

  &:focus + .slider {
    box-shadow: 0 0 1px ${colourPrimary};
  }

  &:checked + .slider::before {
    left: 16px;
  }
`;

class WveInputCheckbox extends Component {
  render() {
    const { value, onChange, placeholder, disabled, label } = this.props;
    const isMultiple = value === MULTIPLE || typeof value !== 'boolean';
    const htmlFor = `switch-${label.replace(/\s+/g, '')}`;
    return (
      <Label
        htmlFor={htmlFor}
      >
        <Input
          id={htmlFor}
          type="checkbox"
          className="form-control"
          value={value}
          checked={value}
          onChange={onChange}
          disabled={isMultiple || disabled}
          placeholder={placeholder}
        />
        <Slider
          className="slider"
        />
      </Label>);
  }
}

WveInputCheckbox.defaultProps = {
  value: false,
  placeholder: '',
  onChange: () => {},
  disabled: false,
  label: '',
};

WveInputCheckbox.propTypes = {
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
};

export default WveInputCheckbox;



// WEBPACK FOOTER //
// ./app/javascript/packs/Shared/components/WveInputs/WveInputCheckbox/WveInputCheckbox.jsx